import React from "react";
import {Container} from "@mui/material";

export function Impressum() {
  return (<>
    <Container >
      <h1>Impressum</h1>
      <p>Logo und weitere Bilder: Chad Peter</p>
      <p>Rezepte: geistes Eigentum vom Erfinder</p>
      <p>Icons:
        https://www.flaticon.com/authors/freepik
        https://www.flaticon.com/authors/graphix-dxinerz
        https://www.flaticon.com/authors/marz-gallery
        https://www.flaticon.com/authors/kerismaker
        https://www.flaticon.com/authors/roundicons
        https://www.flaticon.com/authors/octopocto
        https://www.flaticon.com/authors/bsd
      </p>
    </Container>

  </>)
}
